var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('router-link',{attrs:{"to":_vm.url}},[(_vm.ishow == '1')?_c('img',{staticClass:"logo1",attrs:{"src":_vm.darkLogo,"alt":"Corporate Logo"}}):_vm._e(),(_vm.ishow == '2')?_c('img',{staticClass:"logo2",attrs:{"src":_vm.darkLogo,"alt":"Corporate Logo"}}):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }